module.exports = __webpack_public_path__ + "static/media/utilityImage.dceae8cb.png";